import React from "react";

const PageTitle = ({ title }) => {
  return <div className="page-title pb-4"> {title}</div>;
};

export default PageTitle;
